import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { handleAiAutoGradingSchedule } from 'store/submissions/thunks';
import { useUserProfileConfig } from 'store/users/selectors';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import * as Sentry from '@sentry/react';
import AiGradeAllModal from './AiGradeAllModal';

const AiGradeAllButton = ({
    eligibleSubmissions,
    assignment,
    setAlertSakeBar
}) => {
    const [aiGradeAllModalOpen, setAiGradeAllModalOpen] = useState(false);
    const [selectedSubmissions, setSelectedSubmissions] = useState([]);
    const [aiGradeLoading, setAiGradeLoading] = useState(false);
    const dispatch = useDispatch();
    const { isAiPermissionEnabled } = useUserProfileConfig();
    const showAlert = useAlert();


    const handleOpenAiGradeAllModal = () => {
        if (!isAiPermissionEnabled) {
            showAlert('Please enable AI permission to generate content using AI.', 'error');
            return;
        }
        const eligibleIds = eligibleSubmissions.map(sub => sub.id);
        setSelectedSubmissions(eligibleIds);
        setAiGradeAllModalOpen(true);
    };

    const handleToggleSubmission = (submissionId) => {
        setSelectedSubmissions(prev => {
            if (prev.includes(submissionId)) {
                return prev.filter(id => id !== submissionId);
            } else {
                return [...prev, submissionId];
            }
        });
    };

    const handleSelectAll = () => {
        const eligibleIds = eligibleSubmissions.map(sub => sub.id);
        setSelectedSubmissions(eligibleIds);
    };

    const handleDeselectAll = () => {
        setSelectedSubmissions([]);
    };

    const handleSubmitAiGradeAll = async (submissionIds, grade_level = null) => {
        if (submissionIds.length === 0) {
            showAlert('Please select at least one student.', 'error');
            return;
        }

        try {
            setAiGradeLoading(true);
            const promises = submissionIds.map(submissionId => 
                dispatch(handleAiAutoGradingSchedule(submissionId, null, true, true, grade_level))
            );
            await Promise.all(promises);
            if (setAlertSakeBar) {
                setAlertSakeBar({
                    open: true,
                    message: `AI grading has been scheduled for ${submissionIds.length} assignment(s). Please allow up to 15 minutes for the process to complete.`,
                    severity: 'success'
                });
            }
            setAiGradeAllModalOpen(false);
            setSelectedSubmissions([]);
        } catch (error) {
            Sentry.captureException(`Error in handleSubmitAiGradeAll: ${error}`);
            showAlert('An error occurred while scheduling AI grading. Please try again.', 'error');
        } finally {
            setAiGradeLoading(false);
        }
    };

    const handleClose = () => {
        setAiGradeAllModalOpen(false);
        setSelectedSubmissions([]);
    };

    if (eligibleSubmissions.length === 0) {
        return null;
    }

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                onClick={handleOpenAiGradeAllModal}
                style={{ marginLeft: '16px' }}
            >
                Calificar todo con IA
            </Button>
            <AiGradeAllModal
                open={aiGradeAllModalOpen}
                onClose={handleClose}
                eligibleSubmissions={eligibleSubmissions}
                selectedSubmissions={selectedSubmissions}
                onToggleSubmission={handleToggleSubmission}
                onSelectAll={handleSelectAll}
                onDeselectAll={handleDeselectAll}
                onSubmit={handleSubmitAiGradeAll}
                loading={aiGradeLoading}
            />
        </>
    );
};

export default AiGradeAllButton;
